export default __webpack_public_path__ + "static/media/logoutIcon.43f4997d.svg";